import { useQuery } from '@tanstack/react-query';
import { v4 as uuidv4 } from 'uuid';

import { baseAxios, handleError } from 'api';
import axios from 'axios';

export function useRapidNLCode(nlcode, alcode) {
  const uAxios = axios.create({
    headers: {
      Authorization: `Bearer ${uuidv4()}`,
    },
  });
  let params;
  if (nlcode) {
    params = new URLSearchParams({ nlcode });
  } else {
    params = new URLSearchParams({ alcode });
  }
  return useQuery({
    queryKey: ['nlcode', nlcode || alcode],
    queryFn: () => baseAxios(uAxios, { url: `/rapid/nlcode?${params}` }),
    onError: (err) => {
      handleError(err);
    },
    initialData: [],
    enabled: false,
    retry: false,
  });
}
